import { render } from "./PartTwoOutput.vue?vue&type=template&id=2d9fe876&scoped=true"
const script = {}

import "./PartTwoOutput.vue?vue&type=style&index=0&id=2d9fe876&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9fe876"]])

export default __exports__